import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import { values } from "mobx"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"
import shop  from "shop/shop"
import Responsive                                                from "react-responsive"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }

  // 
  // Sortierung der Liste nach wann der Artikel hinzugefügt wird, sollte es noch ein alter Eintrag sein, wird nach der map_id sortiert.
  // Zeitlich markierte Artikel sind immer unter den nicht markierten Artikel sortiert.
  // 
  sortProductList(list) {
    // create an array from product models
    let sortList = Object.values(list.products);
    // check length
    if (sortList.length > 0) {
      // sort productmodel entries by item position
      return sortList.sort((a,b) => {
        var aval = list.items.get(a.map_id);
        var bval = list.items.get(b.map_id);
        // prüfen ob beide oder nur ein artikel ein zeitstempel hat 
        // wenn beide dann sortierung nach artikelnummer
        if (aval.position < 10000 & bval.position < 10000) {
          if (aval.map_id < bval.map_id) return -1;
          if (aval.map_id > bval.map_id) return 1;
          return 0;
        // nur a hat keine position dann ist a kleiner 
        } else if (aval.position < 1000) {
          return -1;
        // nur b hat keine position dann ist b kleiner 
        } else if (bval.position < 1000) {
          return 1;
        // beide habe eine position 
        } else {
          if (aval.position > bval.position) return 1;
          if (aval.position < bval.position) return -1;
          return 0;
        }
      });
    }
    return sortList;
  }

  render() {
    let { list, cart, products, onChange, sort } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = [];
    //console.log(list);
    if (sort && list) {
      let orderList = this.sortProductList(list);
      rows = _.map( orderList, ( product, index ) => {
        return (
          <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
        )
      } )
    } else {
      rows = _.map( positions, ( product, index ) => {
        return (
          <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
        )
      } )
    }
    return (
      <Fragment>
      <Responsive maxWidth={899}>
        <table className="mobileRespTable" >
          <colgroup>
            <col width="10%"/>
            <col width="90%"/>
            </colgroup>
          <tbody>
          {rows}
          </tbody>
        </table>
      </Responsive>
      <Responsive minWidth={900}>
      <Table>
        <colgroup>
          <col width="5%"/>
          <col width="5%"/>
          <col width="25%"/>
          <col width="15%"/>
          <col width="15%"/>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="10%"/>}
          <col width="10%"/>
          {list && <col width="10%"/>}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<col width="10%"/>}
        </colgroup>
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>{translate( "article" )}</th>
          {/*<th>&nbsp;</th>*/}
          <th>{translate( "deliverable" )}</th>
          {/*<th>Preis/Stück</th>*/}
          {/*<th>{translate( "deliverable" )}</th>*/}
          {/*<th>{translate("Preis/Stück")}</th>*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <th className=""><div className="tr">{translate( "Preis/VE" )}</div></th>}
          <th>{translate( "VE" )}</th>
          <th>{translate( "Kartoninhalt" )}</th>
          {/*list && <th>{translate( "Menge" )}</th>*/}
          {/*<th>{translate( "total count" )}</th>*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&  <th>
            <div className="tr">
              {translate( "sum" )}
            </div>
          </th>}
          {/*<th>{translate( "VE" )}</th>*/}
          {/*<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>*/}
          {list && <th style={{ textAlign: "right" }}>{translate( "" )}</th>}
          <th>{translate( "Menge (VE)" )}</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
      </Responsive>
    </Fragment>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductTable.js